var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C9 1.44772 9.44772 1 10 1C10.5523 1 11 1.44772 11 2V2.08296C10.6748 2.0284 10.3407 2 10 2C9.65929 2 9.32521 2.0284 9 2.08296V2ZM8 2.34141V2C8 0.89543 8.89543 0 10 0C11.1046 0 12 0.89543 12 2V2.34141C14.3304 3.16509 16 5.38756 16 8V13.3486L17.916 16.2226C18.0183 16.3761 18.0278 16.5733 17.9408 16.7359C17.8538 16.8985 17.6844 17 17.5 17H13C13 18.6569 11.6569 20 10 20C8.34315 20 7 18.6569 7 17H2.5C2.3156 17 2.14617 16.8985 2.05916 16.7359C1.97215 16.5733 1.98169 16.3761 2.08397 16.2226L4 13.3486V8C4 5.38756 5.66962 3.16508 8 2.34141ZM5 8V13.5C5 13.5987 4.97078 13.6952 4.91603 13.7773L3.43426 16H16.5657L15.084 13.7773C15.0292 13.6952 15 13.5987 15 13.5V8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8ZM10 19C8.89543 19 8 18.1046 8 17H12C12 18.1046 11.1046 19 10 19Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.c8fdf223e30d0d5f971c1c3a34da9eef.svg";
export { ForwardRef as ReactComponent };